export enum CountryMilestoneDependencyDelayType {
  IMMEDIATE = 'IMMEDIATE',
  LEAD_BY = 'LEAD_BY',
  LAG_BY = 'LAG_BY',
}
